if (!window.fetch) {
    window.fetch = (url, options = {}) => new Promise((resolve, reject) => {
        let request = new XMLHttpRequest();
        request.open(options.method || 'get', url, true);
        for (let i in options.headers) {
            request.setRequestHeader(i, options.headers[i]);
        }
        request.withCredentials = options.credentials == 'include';
        request.onload = () => {
            resolve(response());
        }
        request.onerror = reject;
        request.send(options.body || null);

        function response() {
            let keys = [], all = [], headers = {}, header;
            request.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, (m, key, value) => {
                keys.push(key = key.toLowerCase());
                all.push([key, value]);
                header = headers[key];
                headers[key] = header ? `${header},${value}` : value;
            });
            return {
                ok: (request.status / 100 | 0) == 2,    // 200-299
                status: request.status,
                statusText: request.statusText,
                url: request.responseURL,
                clone: response,
                text: () => Promise.resolve(request.responseText),
                json: () => Promise.resolve(request.responseText).then(JSON.parse),
                blob: () => Promise.resolve(new Blob([request.response])),
                headers: {
                    keys: () => keys,
                    entries: () => all,
                    get: n => headers[n.toLowerCase()],
                    has: n => n.toLowerCase() in headers
                }
            };
        }
    });
}
